























import Vue from 'vue';
import Quiz from '@/web/components/quizzes/Quiz.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  components: {
    Quiz,
  },
  props: {
    studioURL: {
      type: String,
    },
    quizId: {
      type: Number,
    },
    quiz: {
      type: Object,
    },
  },
  data() {
    return {
      solvedQuizProp: null,
      currentQuestionIndexProp: 1,
    };
  },
  methods: {
    getStudioURL() {
      return getStudioURL(this.$route);
    },
    getsolvedQuizProp(value) {
      this.solvedQuizProp = value;
    },
    getCurrentQuestionIndexProp(value) {
      this.currentQuestionIndexProp = value;
    },
    leaveQuiz() {
      this.$modal.show(HMDialog, {
        title: this.$t('QUIZZES.TITLE.EXIT_QUIZ'),
        subtitle: this.$t('GENERAL.TEXT.DO_YOU_REALLY_WANT_TO_DO_IT'),
        text: this.$t(
          'QUIZZES.TEXT.ONLY_ANSWERED_ANSWERS_WILL_BE_SUBMITTED_QUIZ'
        ),
        confirmButton: this.$t('QUIZZES.BUTTON.DISCARD'),
        discardButton: this.$t('QUIZZES.BUTTON.STAY_ON_PAGE'),
        discard: () => {
          console.log('confirmed');
        },
        confirm: () => this.$emit('close'),
      });
    },
    onFinish(solvedQuiz) {
      this.$parent.$emit('finish', solvedQuiz);
      this.$emit('close');
    },
  },
});
